import { useId } from 'react';

interface ValidationWeatherGuidanceProps {
  guidanceText: string | null;
}

/** Displays the server-validated weather guidance without regenerating or interpreting it in the browser. */
export function ValidationWeatherGuidance({ guidanceText }: ValidationWeatherGuidanceProps) {
  const headingId = useId();
  if (!guidanceText) {
    return null;
  }

  return (
    <section className="validation-weather-guidance" aria-labelledby={headingId}>
      <h2 id={headingId}>What this means</h2>
      <p>{guidanceText}</p>
    </section>
  );
}
